module.exports = __webpack_public_path__ + "img/hero.413c685b.png";